import React from 'react';
import FormInput from '../../../components/ui/FormInput';
import Select from 'react-select';
import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

const PassengerInfo = ({ passengers, onChange, onAdd, onRemove }) => {
  const handlePassengerChange = (index, field, value) => {
    onChange(index, field, value);
  };

  const handleSelectChange = (index, field, selectedOption) => {
    handlePassengerChange(index, field, selectedOption ? selectedOption.value : '');
  };

  // Custom styles for react-select
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#3B82F6' : '#D1D5DB',
      boxShadow: state.isFocused ? '0 0 0 2px #DBEAFE' : 'none',
      borderRadius: '0.5rem',
      padding: '2px',
      '&:hover': {
        borderColor: state.isFocused ? '#3B82F6' : '#9CA3AF',
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#3B82F6' : state.isFocused ? '#DBEAFE' : null,
      color: state.isSelected ? 'white' : '#111827',
    }),
  };

  const genderOptions = [
    { value: 'male', label: 'Erkek' },
    { value: 'female', label: 'Kadın' },
    { value: 'other', label: 'Diğer' }
  ];

  return (
    <div className="space-y-8">
      {passengers.map((passenger, index) => (
        <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-sm">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-medium text-gray-900">Yolcu #{index + 1}</h3>
            {passengers.length > 1 && onRemove && (
              <button
                type="button"
                onClick={() => onRemove(index)}
                className="inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                <TrashIcon className="h-4 w-4" />
              </button>
            )}
          </div>
          
          {/* İki satırlı düzen kullanarak sorunu çözüyoruz */}
          <div className="space-y-4">
            {/* İlk satır: Ad, Soyad, Uyruk */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-4">
                <FormInput
                  id={`firstName-${index}`}
                  name={`firstName-${index}`}
                  label="Ad"
                  value={passenger.firstName}
                  onChange={(e) => handlePassengerChange(index, 'firstName', e.target.value)}
                  placeholder="Yolcunun adı"
                  required
                />
              </div>
            
              <div className="col-span-4">
                <FormInput
                  id={`lastName-${index}`}
                  name={`lastName-${index}`}
                  label="Soyad"
                  value={passenger.lastName}
                  onChange={(e) => handlePassengerChange(index, 'lastName', e.target.value)}
                  placeholder="Yolcunun soyadı"
                  required
                />
              </div>
            
              <div className="col-span-4">
                <FormInput
                  id={`nationality-${index}`}
                  name={`nationality-${index}`}
                  label="Uyruk"
                  value={passenger.nationality}
                  onChange={(e) => handlePassengerChange(index, 'nationality', e.target.value)}
                  placeholder="Türkiye"
                />
              </div>
            </div>

            {/* İkinci satır: Kimlik/Pasaport, Cinsiyet */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-6">
                <FormInput
                  id={`identityNumber-${index}`}
                  name={`identityNumber-${index}`}
                  label="Kimlik/Pasaport No"
                  value={passenger.identityNumber}
                  onChange={(e) => handlePassengerChange(index, 'identityNumber', e.target.value)}
                  placeholder="Kimlik veya pasaport numarası"
                />
              </div>
            
              <div className="col-span-6">
                <label htmlFor={`gender-${index}`} className="block text-sm font-medium text-gray-700 mb-1.5">
                  Cinsiyet
                </label>
                <Select
                  id={`gender-${index}`}
                  name={`gender-${index}`}
                  options={genderOptions}
                  value={genderOptions.find(option => option.value === passenger.gender)}
                  onChange={(option) => handleSelectChange(index, 'gender', option)}
                  placeholder="Cinsiyet seçiniz"
                  isClearable
                  styles={customStyles}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>
            </div>
          </div>

        </div>
      ))}

      {onAdd && (
        <div className="text-center">
          <button
            type="button"
            onClick={onAdd}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <PlusIcon className="h-4 w-4 mr-2" />
            Yolcu Ekle
          </button>
        </div>
      )}
    </div>
  );
};

export default PassengerInfo;